import { memo } from "react";
import CreateDepartmentForm from "./components/CreateDepartmentForm";
import { useNavigate } from "react-router-dom";
import { ApplicationRoutes } from "../../../routes";

const CreateDepartmentPage = memo(() => {
	const navigate = useNavigate();

	const handleCancel = () => {
		navigate(`/${ApplicationRoutes.ADMIN_UTIL_BASE}/${ApplicationRoutes.SERVICE_REQUEST_MODULE}/${ApplicationRoutes.DEPARTMENT_CONFIGURATION}`);
	};

	return <CreateDepartmentForm onCancel={handleCancel} />;
});

export default CreateDepartmentPage;
